// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-2y5y167Q","foot_link":"foot_link-2bDNzc8M","list":"list-37IGsaBA","link":"link-1qw__zKj","copyright":"copyright-3ADpuWOA"};